/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalEhrType } from './ExternalEhrType';
import {
    ExternalEhrTypeFromJSON,
    ExternalEhrTypeFromJSONTyped,
    ExternalEhrTypeToJSON,
    ExternalEhrTypeToJSONTyped,
} from './ExternalEhrType';

/**
 * 
 * @export
 * @interface ExternalEhrFacility
 */
export interface ExternalEhrFacility {
    /**
     * 
     */
    facility_id?: string;
    /**
     * 
     */
    type?: ExternalEhrType;
    /**
     * 
     */
    external_organization_id?: string;
    /**
     * Organization short code used by the external EHR (e.g. PCC's "IMR").
     */
    external_organization_code?: string;
    /**
     * 
     */
    external_facility_id?: string;
    /**
     * PCC Consumer Site ID. Falls back to <external_organization_code><zero-padded external_facility_id> when not explicitly stored.
     */
    external_consumer_site_id?: string;
}



/**
 * Check if a given object implements the ExternalEhrFacility interface.
 */
export function instanceOfExternalEhrFacility(value: object): value is ExternalEhrFacility {
    return true;
}

export function ExternalEhrFacilityFromJSON(json: any): ExternalEhrFacility {
    return ExternalEhrFacilityFromJSONTyped(json, false);
}

export function ExternalEhrFacilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEhrFacility {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'] == null ? undefined : json['facility_id'],
        'type': json['type'] == null ? undefined : ExternalEhrTypeFromJSON(json['type']),
        'external_organization_id': json['external_organization_id'] == null ? undefined : json['external_organization_id'],
        'external_organization_code': json['external_organization_code'] == null ? undefined : json['external_organization_code'],
        'external_facility_id': json['external_facility_id'] == null ? undefined : json['external_facility_id'],
        'external_consumer_site_id': json['external_consumer_site_id'] == null ? undefined : json['external_consumer_site_id'],
    };
}

export function ExternalEhrFacilityToJSON(json: any): ExternalEhrFacility {
    return ExternalEhrFacilityToJSONTyped(json, false);
}

export function ExternalEhrFacilityToJSONTyped(value?: ExternalEhrFacility | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_id': value['facility_id'],
        'type': ExternalEhrTypeToJSON(value['type']),
        'external_organization_id': value['external_organization_id'],
        'external_organization_code': value['external_organization_code'],
        'external_facility_id': value['external_facility_id'],
        'external_consumer_site_id': value['external_consumer_site_id'],
    };
}

